import React from "react";

const Meta = ({ user }) => {
  return (
    <div className="space-y-1">
      {user?.meta?.club && (
        <div className="mb-2">
          <label className="text-white capitalize block">Club</label>
          <span className="bg-amber-500 text-black rounded-lg px-2 py-1 inline-block">
            {user.meta.club}
          </span>
        </div>
      )}

      {user?.meta?.personality && user.meta.personality.length > 0 && (
        <div>
          <label className="text-white capitalize block">Personality</label>
          <div className="flex flex-wrap gap-2">
            {user.meta.personality.map((trait, index) => (
              <span
                key={index}
                className="bg-amber-500 text-black rounded-lg px-2 py-1"
              >
                {trait}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Meta;
